import "./EditModal.scss";
import Form from "../Form/Form";

const EditModal = ({
  openEditModal,
  setOpenEditModal,
  editHandler,
  item,
  editErrors,
}) => {
  if (!openEditModal) {
    return;
  }

  return (
    <section className="editModal">
      <Form
        setOpenEditModal={setOpenEditModal}
        editHandler={editHandler}
        item={item}
        formErrors={editErrors}
      />
    </section>
  );
};

export default EditModal;
